import WithdrawalsGrid from "./WithdrawalsGrid";

/**
 * Renders the "WithdrawalsPage" page
 * @returns {JSX.Element}
 * @constructor
 */
const WithdrawalsPage = () => {
    return (
        <div>
            <WithdrawalsGrid />
        </div>
    );
}

export default WithdrawalsPage;
